import { css } from "styled-components";
import { isFunction } from "lodash";

const runConditionCheck = (condition, props) => {
  const isFunctionAndPasses = isFunction(condition) && condition(props);
  const isNotFunctionAndIsTruthy = !isFunction(condition) && !!condition;
  return isFunctionAndPasses || isNotFunctionAndIsTruthy;
};

export const cssIf = (condition) => (styles, ...interpolations) => (props) => {
  if (runConditionCheck(condition, props)) {
    return css.apply(null, [styles, interpolations]);
  } else {
    return "";
  }
};